import { useEsaShellEffects } from '../hooks/useEsaShellEffects';

/**
 * Host-only bridge that must stay mounted whenever a canvas/workspace can emit
 * ESA context. Lives in Layout — not inside EsaPanel — so selection events are
 * captured even when the panel is collapsed.
 */
export function EsaShellEffectsBridge(): null {
  if (process.env.NODE_ENV !== 'production') {
    console.log('[ESA host] EsaShellEffectsBridge mounted');
  }
  useEsaShellEffects();
  return null;
}
